import type { Category, CategoryDetail, CategoryNode } from '@sshop/domain';

import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

import type { CategoryService } from './CategoryService';
import { categoryDetailDto, categoryDto, categoryTreeDto } from './category.dto';
import { toCategory, toCategoryDetail, toCategoryTree } from './category.mapper';

export function createLaravelCategoryService(transport: Transport): CategoryService {
  return {
    async tree(signal): Promise<readonly CategoryNode[]> {
      const res = await transport.request({
        method: 'GET',
        path: '/categories',
        ...(signal !== undefined ? { signal } : {}),
      });
      return toCategoryTree(parseDto(categoryTreeDto, res.data, 'GET /categories').data);
    },

    async getBySlug(slug: string, signal): Promise<Category> {
      const res = await transport.request({
        method: 'GET',
        path: `/categories/${encodeURIComponent(slug)}`,
        ...(signal !== undefined ? { signal } : {}),
      });
      return toCategory(parseDto(categoryDto, res.data, `GET /categories/${slug}`));
    },

    async getDetail(slug: string, signal): Promise<CategoryDetail> {
      const res = await transport.request({
        method: 'GET',
        path: `/categories/${encodeURIComponent(slug)}`,
        ...(signal !== undefined ? { signal } : {}),
      });
      return toCategoryDetail(
        parseDto(categoryDetailDto, res.data, `GET /categories/${slug} (detail)`),
      );
    },
  };
}
